<template>
  <div class="input-model-box">
    <el-input
      placeholder="请输入名称或编码"
      v-model="wholesaleCustomerName"
      @blur="wholesaleCustomerNameChange"
      :disabled="column.disabled">
      <template slot="append">
        <div class="el-icon-more more-btn" @click="showWholesaleCustomerList"></div>
      </template>
    </el-input>
    <el-dialog
      :title="column.label"
      :visible.sync="dialogVisible"
      @close="beforeClose"
      center
      :modal-append-to-body="false">
      <purchase-list-template ref="listTable" @rowClick="wholesaleCustomerCheck" :tableOptions="tableOptions"/>
    </el-dialog>
  </div>
</template>
<script>
import api from "@/config/api";
import purchaseListTemplate from '@/components/template/purchaseListTemplate.vue';

export default {
  components: {purchaseListTemplate},
  props: ["column", "defaultValue"],
  data() {
    return {
      wholesaleCustomerName: "",
      checkList: [],
      dialogVisible: false,
      wholesaleCustomerList: null,
      tableOptions: {
        url: api.wholesale.archives + "/page",
        height: "100%",
        isRowClick: true,
        columns: [
          {label: "编码", prop: "code", align: "center"},
          {label: "名称", prop: "name", align: "center"}
        ]
      },
      btnClick: false
    };
  },
  watch: {
    defaultValue() {
      if (this.defaultValue > 0) {
        this.$axios
          .fetchGet(api.wholesale.archives + "?id=" + this.defaultValue)
          .then(res => {
            console.log(res);
            this.wholesaleCustomerName = res.data.name;
          });
      }
    }
  },
  methods: {
    initData() {
      this.wholesaleCustomerName = "";
      this.checkList = {};
    },
    showWholesaleCustomerList() {
      if (this.column.disabled) return;
      this.btnClick = true;
      this.dialogVisible = true;
      this.getWholesaleCustomerList();
    },
    wholesaleCustomerNameChange() {
      if (this.btnClick) return;
      if (this.wholesaleCustomerName === "" || this.wholesaleCustomerName === null) return;
      this.dialogVisible = true;
      this.getWholesaleCustomerList();
    },
    getWholesaleCustomerList() {
      if (this.btnClick) this.wholesaleCustomerName = "";
      this.wholesaleCustomerList = [];
      this.$nextTick(() => {
        this.$refs["listTable"].initData({
          storeId: this.column.params && this.column.params.wholesaleCustomerId,
          name: this.wholesaleCustomerName
        });
        this.setWholesaleCustomerName();
      });
    },
    setWholesaleCustomerName() {
      if (this.wholesaleCustomerList.length === 1) {
        this.checkList = this.wholesaleCustomerList[0];
        this.wholesaleCustomerName = this.wholesaleCustomerList[0].name;
        this.$emit("valueChange", this.checkList.id, this.column);
      } else {
        this.dialogVisible = true;
      }
    },
    wholesaleCustomerCheck(row) {
      this.checkList = row;
      this.wholesaleCustomerName = row.name;
      this.dialogVisible = false;
      this.$emit("valueChange", row.id, this.column);
    },
    beforeClose() {
      this.wholesaleCustomerName = this.checkList.name;
      this.btnClick = false;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/business/wholesaleCustomerInputDialog.vue